
import WDPaneForm from '../gui/pane/wd-pane-form';
import WDApi from '../core/fetch/wd-api';
import WDActivity from '../gui/modal/wd-activity';
import WDButton from '../gui/button/wd-button';
import WDPasswordChecker from './wd-password-checker';

export default class WDPasswordReset extends WDPaneForm {

	#key = null;
	#submitBtn = null;

	constructor(params)
	{	
		super({title:'Reset Your Password',wrapper_class:'col-12'});

		//make sure the key is valid
		this.#key = new WDApi('/passwordreset/' + params.resetKey);
	};
	
	connectedCallback()
	{
		super.connectedCallback();
		
		this.#key.req().then( data => {

			if (data?.id)
			{
				this.buildForm();
			}
			else 
			{
				let m = new WDActivity().showError('Invalid key specified');
				m.addButton({label:'Close',theme:'primary',click:() => m.hide()});
				m.on('modal:hide',() => location.href = '/' );
			}

		});
	};
	
	buildForm()
	{
		const msg = wdc('<h5>Reset Your Password</h5>');
		this.body.prepend(msg);
		
		this.#submitBtn = new WDButton({label:'Save New Password',fasIcon:'save',theme:'primary',click:() => this.submit()});

		this.addForms([	
			{name:'password1',label:'Enter Your New Password',type:'password',required:true},
			{name:'password2',label:'Again To Confirm',type:'password',required:true},
		]).then( () => {
			this.body.append( this.#submitBtn );
			new WDPasswordChecker(this.getItem('password1'),this.getItem('password2'),this.#submitBtn);		
		});
	};

	submit()
	{
		this.#submitBtn.busy = true;
		
		this.#key.password = this.value.password1;
		this.#key.post().then( data => {

			this.#submitBtn.busy = false;
			
			let m = new WDActivity().showMessage('Password reset successfully.	You may now log in.');
			m.addButton({label:'Close',theme:'primary',click:() => m.hide()});
			m.on('modal:hide',() => location.href = '/' );
		});

	};

};

customElements.define('wd-password-reset',WDPasswordReset);
